<template>
    <ion-page>
        <ion-loading :is-open="loading" message="Loading, please wait"/>
        <ion-content>
            <standard-header title="Select Items" align="middle" />
            <ion-item v-for="(item,index) in lines" :key="index">
                <ion-list style="width: 100%">
                    <ion-item>
                        <ion-label class="ion-text-wrap">
                            <h2>{{ item.description }}</h2>
                            <p>
                                {{ item.item_number }}
                            </p>
                        </ion-label>
                        <ion-button v-if="lines.length > 1" slot="end" color="danger" @click="trashLine(index)">
                            Delete
                        </ion-button>
                    </ion-item>
                    <ion-item class="ion-padding-top" lines="none">
                        <big-stepper label="Qty Accepted" v-model="item.qty_accepted" />
                    </ion-item>
                    <ion-item class="ion-padding-top" lines="none">
                        <big-stepper label="Qty Binned" v-model="item.qty_binned" />
                    </ion-item>
                </ion-list>
            </ion-item>
            <ion-item lines="none">
                <ion-label class="ion-text-wrap" v-if="hasScannedItem">
                    <h2>{{ params.upliftItemName }}</h2>
                    <p>{{ scannedItem.skus[0].sku }} | {{ scannedItem.item_number }}</p>
                </ion-label>
                <ion-label v-else class="ion-text-center">
                    <h2>Add more items - scan/search</h2>
                </ion-label>
                <ion-button size="medium" color="primary" @click="openItemScanner()">
                    <ion-icon slot="icon-only" :icon="barcode"/>
                </ion-button>
                <ion-button expand="block" color="primary" size="medium" @click="openItemPicker()">
                    <ion-icon slot="icon-only" :icon="search"/>
                </ion-button>
            </ion-item>
        </ion-content>
        <ion-footer>
            <ion-button color="warning" class="ion-margin-top" size="large" expand="full" @click="complete">
                Next
            </ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {
    alertController,
    IonButton,
    IonContent, IonFooter,
    IonIcon,
    IonItem,
    IonLabel, IonList,
    IonLoading,
    IonPage
} from "@ionic/vue";
import StandardHeader from "../../../../components/StandardHeader";
import {Capacitor} from "@capacitor/core";
import ItemSearchModalHelper from "../../../../services/ItemSearchModalHelper";
import {barcode, checkmarkCircle, listOutline, search} from "ionicons/icons";
import BigStepper from "../../../../components/BigStepper";

export default {
    name: "UpdateMulti",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        IonPage,
        IonContent,
        StandardHeader,
        IonItem,
        IonLabel,
        IonButton,
        IonIcon,
        IonLoading,
        IonList,
        BigStepper,
        IonFooter
    },
    watch: {
        params(val){
            if(val.id && val.item) {
                this.lines = [{
                    item_id: val.item,
                    qty_accepted: val.qty_accepted,
                    qty_binned: val.qty_binned,
                    description: val.description,
                    item_number: val.item_number
                }];
            }
        }
    },
    mounted(){
        const val = this.params
        this.lines = [
            {
                item_id: val.item,
                qty_accepted: val.qty_accepted,
                qty_binned: val.qty_binned,
                description: val.description,
                item_number: val.item_number
            }
        ]
    },
    computed: {
        hasScannedItem() {
            return this.scannedItem && this.scannedItem.id > 0;
        },
        skipUplifts() {
            return this.$route.query.skip_uplifts;
        },
        params() {
            return this.$route.params
        }
    },
    methods: {
        complete(){
            this.loading = true;
            const url = this.skipUplifts?'/api/uplifts/update-without-uplift':`/api/uplift-lines/${this.params.id}`;
            this.$http.put(url, {
                lines: this.lines,
                location: this.params.location,
                reason: this.params.reason,
                // sending this so the server can do some checking
                // to say "if it's just a single line, the maths must match"
                qty_received: this.params.qty_received
            }).then(response => {
                this.$toast.success("Items Accepted");
                this.loading = false;
                this.$router.push({name: 'warehouse.uplifts.index'})
            }).catch(error => {
                this.$validationAlert(error)
                this.loading = false;
            })
        },
        trashLine(index){
            this.lines.splice(index, 1)
        },
        async openItemScanner() {
            if (Capacitor.platform === 'web') {
                const alert = await alertController.create({
                    header: 'Enter Item #ID',
                    inputs: [{
                        type: 'number',
                        name: 'item_id'
                    }],
                    buttons: ['Ok']
                });
                alert.onDidDismiss().then(input => {
                    const id = input.data.values.item_id;
                    this.$http.get(`/api/items/${id}`)
                        .then(response => {
                            this.lines.push(
                                {
                                    qty_accepted: 0,
                                    qty_binned: 0,
                                    item_id: response.data.id,
                                    description: response.data.name,
                                    item_number: response.data.item_number
                                }
                            )
                        });
                });
                alert.present();
                return;
            }
            this.$scanner.search().then(result => {
                this.lines.push(
                    {
                        qty_accepted: 0,
                        qty_binned: 0,
                        item_id: result.id,
                        description: result.name,
                        item_number: result.item_number
                    }
                )
            }).catch(error => {
                this.$toast.danger(error);
            });
        },
        openItemPicker() {
            ItemSearchModalHelper.open(this.include).then(item => {
                if (! (item.data && item.data.id)) {
                    return;
                }
                this.lines.push(
                    {
                        qty_accepted: 0,
                        qty_binned: 0,
                        item_id: item.data.id,
                        description: item.data.name,
                        item_number: item.data.item_number
                    }
                )
            });
        },
    },
    data(){
        return {
            loading: false,
            scannedItem: {},
            lines: []
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline
        }
    }
}
</script>

<style scoped>

</style>